<template>
    <div>
        <page-header :heading="pageHeader.title" />
        <div v-if="loading" class="text-center">
            <b-spinner label="Spinning"></b-spinner>
        </div>
        <file-progress v-else :files="fileProgress" />
        <button type="button" class="btn btn-outline-primary mr-1" @click="goBack"><i class="fas fa-backward"></i> Back</button>
    </div>
</template>
<script>
    import PageHeader from '@/components/PageHeader.vue'
    import FileProgress from "@/components/FileProgress.vue";
    import { mapActions, mapGetters } from "vuex";
    export default {
        components: {
            'page-header': PageHeader,
            'file-progress': FileProgress
        },
        data: () => {
            return {
                pageHeader: {
                    title: 'Supplier Import file progress'
                },
                fileId: null,
                loading: false
            }
        },
        computed: {
            ...mapGetters({
                fileProgress: 'suplPayments/getWorkItemFileProgress'
            }),
        },
        methods: {
            ...mapActions({
                loadWorkItemFileProgress: "suplPayments/getWorkItemFilesProgress",
                reset: 'suplPayments/resetWorkItemFilesProgress'
            }),
            goBack() {
                if (window.history.length > 1) {
                    this.$router.go(-1); // or this.$router.back();
                } else {
                    // If no history, navigate to a default route
                    this.$router.push("/finance/supplierpayments/");
                }
            }
        },
        mounted() {
            this.loading = true
            this.reset()
            const param = this.$route.params.id
            if (param !== null && param !== undefined) {
                console.log('-param: ', param)
                this.fileId = this.$route.params.id
            }
            
            console.log('this.fileId: ', this.fileId)
            this.loadWorkItemFileProgress(this.fileId).finally(() => {
                this.loading = false
            })
        }
    }
</script>